(function () {
  'use strict';
  var instances = new WeakMap();

  function initGallery(root) {
    if (!root || instances.has(root)) return;
    var track = root.querySelector('[data-elite-track]');
    var viewport = root.querySelector('[data-elite-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-elite-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-elite-dot]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-elite-thumb]'));
    var prev = root.querySelector('[data-elite-prev]');
    var next = root.querySelector('[data-elite-next]');
    if (!track || !viewport || slides.length < 1) return;
    var index = 0, timer = null, touchStart = null, touchDelta = 0;
    var autoplayMs = 4200;

    function isMobileTablet() { return window.matchMedia('(max-width: 1024px)').matches; }
    function render(i, animate) {
      index = (i + slides.length) % slides.length;
      track.style.transition = animate === false ? 'none' : 'transform 420ms cubic-bezier(.22,.61,.36,1)';
      track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
      slides.forEach(function(s,n){ s.classList.toggle('is-active', n === index); });
      dots.forEach(function(d,n){ var a=n===index; d.classList.toggle('is-active',a); d.setAttribute('aria-selected',a?'true':'false'); });
      thumbs.forEach(function(t,n){ t.classList.toggle('active',n===index); });
    }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function start(){ stop(); if(isMobileTablet() && slides.length>1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){ timer=setInterval(function(){ render(index+1,true); },autoplayMs); } }
    function go(i){ render(i,true); if(isMobileTablet()) start(); }

    if (prev) prev.addEventListener('click', function(e){e.preventDefault();e.stopPropagation();go(index-1);});
    if (next) next.addEventListener('click', function(e){e.preventDefault();e.stopPropagation();go(index+1);});
    dots.forEach(function(d){d.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(Number(d.getAttribute('data-elite-dot')));});});
    thumbs.forEach(function(t){t.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();go(Number(t.getAttribute('data-elite-thumb')));});});

    viewport.addEventListener('touchstart', function(e){ if(!e.touches[0]) return; touchStart=e.touches[0].clientX; touchDelta=0; stop(); }, {passive:true});
    viewport.addEventListener('touchmove', function(e){ if(touchStart===null || !e.touches[0]) return; touchDelta=e.touches[0].clientX-touchStart; }, {passive:true});
    viewport.addEventListener('touchend', function(){ if(touchStart===null)return; if(Math.abs(touchDelta)>45) go(index+(touchDelta<0?1:-1)); else start(); touchStart=null; touchDelta=0; });
    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', start);

    document.addEventListener('keydown', function(e){ if(!root.offsetParent) return; if(e.key==='ArrowLeft') go(index-1); if(e.key==='ArrowRight') go(index+1); });
    var resizeTimer; window.addEventListener('resize',function(){clearTimeout(resizeTimer);resizeTimer=setTimeout(function(){render(index,false);start();},120);});
    render(0,false); start();
    instances.set(root,{goTo:go,goToImageByUrl:function(url){
      var clean=(url||'').split('?')[0];
      var found=slides.findIndex(function(slide){var img=slide.querySelector('img'); return img && (img.currentSrc||img.src||'').split('?')[0]===clean || (img && img.getAttribute('src')||'').split('?')[0]===clean;});
      if(found>=0) go(found);
    }});
  }

  function boot(){document.querySelectorAll('[data-elite-gallery]').forEach(initGallery); var root=document.querySelector('[data-elite-gallery]'); if(root){window.NUPEPEliteGallery=instances.get(root)||window.NUPEPEliteGallery;}}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:select',boot);
})();
